import React from "react";

/**
 * Apple-TV style radar sweep / scanning shimmer overlaid on a panel.
 * Toned down so content underneath stays readable.
 */
export default function RadarSweep({ active = false, label = "Scanning markets" }) {
  if (!active) return null;
  return (
    <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none z-[5]" data-testid="radar-sweep">
      {/* subtle sweep line */}
      <div
        className="absolute -inset-x-12 -inset-y-12"
        style={{
          background: "linear-gradient(110deg, transparent 38%, rgba(0,255,156,0.05) 49%, rgba(255,255,255,0.07) 50%, rgba(0,255,156,0.05) 51%, transparent 62%)",
          animation: "sweep 1.8s linear infinite",
          opacity: 0.7,
        }}
      />
      {/* corner glow */}
      <div
        className="absolute inset-x-0 top-0 h-24"
        style={{ background: "radial-gradient(600px 200px at 50% 0%, rgba(0,255,156,0.05), transparent 70%)" }}
      />
      {/* label */}
      <div className="absolute top-3 right-3 flex items-center gap-2 px-2.5 py-1 rounded-full bg-black/55 border border-[var(--bull)]/30 backdrop-blur-md" data-testid="radar-label">
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--bull)] pulse-dot" />
        <span className="text-[10px] font-mono uppercase tracking-widest text-[var(--bull)]">{label}</span>
      </div>
    </div>
  );
}
